import React, { useEffect, useState } from "react";
import {
 LineChart,
 Line,
 XAxis,
 YAxis,
 CartesianGrid,
 Tooltip,
 ResponsiveContainer,
} from "recharts";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";



const SalesChartWithTabs = ({ todaySalesList, yesterdaySalesList, weekSalesList, monthSalesList }) => {

 const [salesData, setSalesData] = useState({
  today: todaySalesList,
  yesterday: yesterdaySalesList,
  week: weekSalesList,
  month: monthSalesList
 })

 const [activeTab, setActiveTab] = useState("today");

 const handleTabChange = (tab) => {
  setActiveTab(tab);
 };

 function sortByDate(list) {
  return list.sort((a, b) => new Date(a.date) - new Date(b.date));
 }

 const formatDate = (date) => {
  if (activeTab === "today" || activeTab === "yesterday") {
   return moment(date).format("HH:mm"); // Show time (24-hour format)
  }
  return moment(date).format("MMM DD, YYYY"); // Default date format
 };

 const formatTooltipDate = (date) => {
  if (activeTab === "today" || activeTab === "yesterday") {
   return moment(date).format("HH:mm"); // Show time in tooltip
  }
  return moment(date).format("MMMM Do, YYYY HH:mm"); // Full date and time
 };

 return (
  <div>
   <nav className="nav nav-tabs">
    <button
     className={`nav-link text-black ${activeTab === "today" ? "active" : ""}`}
     onClick={() => handleTabChange("today")}
    >
     Today
    </button>
    <button
     className={`nav-link text-black ${activeTab === "yesterday" ? "active" : ""}`}
     onClick={() => handleTabChange("yesterday")}
    >
     Yesterday
    </button>
    <button
     className={`nav-link text-black ${activeTab === "week" ? "active" : ""}`}
     onClick={() => handleTabChange("week")}
    >
     This Week
    </button>
    <button
     className={`nav-link text-black ${activeTab === "month" ? "active" : ""}`}
     onClick={() => handleTabChange("month")}
    >
     This Month
    </button>
   </nav>
   {salesData[activeTab]?.length ? (
    <div style={{ marginTop: "0px" }}>
     <ResponsiveContainer width="100%" style={{ padding: 0 }} height={250}>
      <LineChart
       data={sortByDate(salesData[activeTab])}
       margin={{
        top: 10,
        right: 0,
        left: 0,
        bottom: 0,
       }}
      >
       <defs>
        <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
         <stop offset="0%" stopColor="#8884d8" stopOpacity={0.8} />
         <stop offset="100%" stopColor="#8884d8" stopOpacity={0} />
        </linearGradient>
       </defs>
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis
        dataKey={"date"}
        tickFormatter={(tick) => formatDate(tick)}
       />
       <YAxis />
       <Tooltip
        contentStyle={{ padding: "2px 2px", borderRadius: "4px", backgroundColor: "#f5f5f5", border: "1px solid #ccc" }}
        labelFormatter={(label) => (
         <small>{formatTooltipDate(label)}</small>
        )}
        formatter={(value) => (
         <small>{value}</small>
        )}
       />
       <Line
        type="monotone"
        dataKey="amount"
        stroke="black"
        fillOpacity={0}
        strokeWidth={1}
        // fill="url(#backgroundGradient)"
        dot={false}
       // isAnimationActive={true}
       />
      </LineChart>
     </ResponsiveContainer>
    </div>
   ) : (
    <h4 className="py-5 mb-4">No record found.</h4>
   )}

  </div>
 );
};

export default SalesChartWithTabs;
